import { createVNode as a, mergeProps as n } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/StopOutlinedStandard.js";
import i from "../components/PfIcon.js";
const t = (r, o) => {
  const e = {
    ...r,
    ...o.attrs
  };
  return a(i, n(e, {
    icon: d
  }), null);
};
t.displayName = "StopOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
